var map = {
	"./byz.png": 2901,
	"./cnz.png": 2902,
	"./dzz.png": 2903,
	"./jnz.png": 2904,
	"./jxz.png": 2905,
	"./mjz.png": 2906,
	"./spz.png": 2907,
	"./ssz.png": 2908,
	"./syz.png": 2909,
	"./szz.png": 2910,
	"./tcz.png": 2911,
	"./txz.png": 2912
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3057;


//////////////////
// WEBPACK FOOTER
// ./containers/Show-new/images/constellation ^\.\/.*\.png$
// module id = 3057
// module chunks = 0